export default __webpack_public_path__ + "static/media/subterfuge.02c0310b.png";